import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import App from './App';
import './index.css';

// Initialize Sentry
const VITE_SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
const hasValidSentryDsn =
  typeof VITE_SENTRY_DSN === 'string' &&
  VITE_SENTRY_DSN.includes('@') &&
  !VITE_SENTRY_DSN.includes('GET_FROM_SENTRY.IO') &&
  !VITE_SENTRY_DSN.includes('your-sentry-dsn');

if (hasValidSentryDsn) {
  Sentry.init({
    dsn: VITE_SENTRY_DSN,
    integrations: [new BrowserTracing()],
    tracesSampleRate: import.meta.env.PROD ? 0.02 : 0.1,
    environment: import.meta.env.MODE,
    beforeSend(event) {
      // Filter sensitive data
      if (event.request?.headers) {
        event.request.headers = {
          ...event.request.headers,
          Authorization: '[REDACTED]',
          'X-API-Key': '[REDACTED]',
        };
      }
      return event;
    },
  });
  console.log('✅ Sentry initialized (frontend)');
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
